import { Component, OnInit, AfterViewInit, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA, MatPaginator,
        MatSort } from '@angular/material';
import { ISubscription } from "rxjs/Subscription";
import { TopnavService } from '../header/topnav/topnav.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { FormControl, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import {
  MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule
} from '@angular/material';
import { Http } from '@angular/http';
import * as $ from 'jquery';
import { tileLayer, latLng, circle, polygon, marker, icon, Layer } from 'leaflet';

import 'leaflet';
import 'leaflet.markercluster';
import * as L from 'leaflet';
// const L = window['L'];
// import 'esri-leaflet';
import { SharedService } from '../common/shared.service';
import { PortalService } from '../services/portal.service';
import { ToastrService } from 'ngx-toastr';
import { NavService } from '../header/nav/nav.service';
import { equalParamsAndUrlSegments } from '@angular/router/src/router_state';

export interface DialogData {
  dataschool;
  typeData;
  phone;
  fax;
}

/**
 * Author: Noraini A.Ghani
 * 
 * Date Created: July 5th 2018
 * 
 * Description: Component class for School Search - /education
 **/
@Component({
  selector: 'gosg-schoolsearch',
  templateUrl: './schoolsearch.component.html',
  styleUrls: ['./schoolsearch.component.css']
})

export class SchoolsearchComponent implements OnInit, AfterViewInit, OnDestroy {

  public myflag: any;
  lang: any;
  langID: any;
  complete: boolean;
  validNS: boolean;
  completeLatLong = true;
  dataAppSchool = null;
  recordData = null;
  dataAppSchoolAll = null;
  recordDataAll = null;
  showNoData = false;
  loading = false;
  limit = 15;

  private typingTimer: any;
  private doneTypingInterval:number = 1200;

  currlang: string = '';
  currlangMOB: string = '';
  isActive

  public valInstituteLevel: any;
  public listObj: any;
  public listLevel: any;
  public listState: any;
  public listSector: any;
  public listPpd: any;
  public listTypeS: any;
  public tempTypeSchool = '';
  public tempPpd = '';
  public tempKhas = '';
  
  public listKhas = [{id: "A", text_ms: "Semua", text_en:"Semua"},{id: "Y", text_ms: "Ada", text_en:"Ada"},{id: "N", text_ms: "Tiada", text_en:"Tiada"}]
  public listCategory = [{id:1, text_ms:"Kategori Institusi", text_en:"Institutional Category"},
                          {id:2, text_ms:"Nama Institusi", text_en:"Institutional Name"},//];
                          {id:3, text_ms:"Lokasi Pengguna", text_en:"User Location"}];
  public listJarak = [{id:3000, text: "3 KM"},{id:5000, text: "5 KM"}, {id:10000, text: "10 KM"}, {id:15000, text: "15 KM"}, {id:20000, text: "20 KM"}];
  public listLokasi = [{id: 1, text_en: "Your Location", text_ms: "Lokasi Anda"}, {id: 2, text_en: "Selected Location", text_ms: "Lokasi yang dipilih"}]
  public listTKK =  [{id: 1, text_en: "Institution Name and Address", text_ms: "Nama dan Alamat Institusi"}, {id: 2, text_en: "Programme", text_ms: "Program"}]
  public originalRecord = 0;
  public noOfSc: any;
  public pageNo = 1;
  public totalPageNo = 1;
  public setLat: any;
  public setLong: any;
  public showDetails = false;

  searchForm: FormGroup;
  public optSelect: FormControl;
  public state: FormControl;
  public typeSchool: FormControl;
  public sector: FormControl;
  public ppd: FormControl;
  public speacialEd: FormControl;
  public schoolname: FormControl;
  public jenisCarian: FormControl;
  public searchString: string;
  public typeLocation: FormControl;
  public latitude: FormControl;
  public longitude: FormControl;
  public distance: FormControl;

  kkForm: FormGroup;
  public typeKK: FormControl;
  public kk: FormControl;

  geolokasiT = '';
  geolokasi1 = '';
  geolokasi2 = '';
  geolokasi3 = '';

  mymap;
  marker;
  markerGroup;
  markerUser;
  circleUser;
  circleRad;
  popup = L.popup();
  defaultIcon = L.icon({
    iconUrl: 'assets/marker/marker-icon-yellow.png',
    shadowUrl: 'assets/marker-shadow.png',
    iconSize: [15, 24], // size of the icon 25, 41
    shadowSize: [20, 21], // size of the shadow 40, 41
    iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location
    shadowAnchor: [15/2, 24],  // the same for the shadow
    popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
  });

  private subscriptionLang: ISubscription;
  private subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;

  public fontSize: any = {
    "sizeS" : "14px",
    "sizeM" : "19px",
    "sizeL" : "23px",
    "no_styles" : "0.9em"
  };
  private mStyle: string; 
  // public eRatingUrl: string = 'https://goserating.mampu.gov.my/erating-public?services_key=54dfc16a-5b4a-11e9-846c-005056a30c08'; 
  // public manualUrl: string =  '/media/documents/Tatacara%20-%20Carian%20sekolah%20di%20Malaysia.pdf';
  public eRatingUrl: string = ''; 
  public manualUrl: string =  '';
  dsvcCode: number;
  agcCode: number;
  titleServices: any;

  constructor(

    private sharedService: SharedService,
    private portalservice: PortalService,
    private activatedRoute: ActivatedRoute,
    private navService: NavService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private http: Http,
    private toastr: ToastrService,
    @Inject(APP_CONFIG) private config: AppConfig,
    public dialog: MatDialog,
    private topnavservice: TopnavService,
    ) {

    //this.navService.restricted = false;
    this.navService.digitalTop = true;
    // this.lang = translate.currentLang;

    // if (translate.getDefaultLang() == 'ms') {
    //   this.currlang = 'English';
    //   this.currlangMOB = 'EN';
    //   this.langID = 2;
    // } else {
    //   this.currlang = 'Bahasa Malaysia';
    //   this.currlangMOB = 'BM';
    //   this.langID = 1;
    // }
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const myLang = translate.currentLang;

      if (myLang == 'en') {

          translate.get('HOME').subscribe((res: any) => {
              this.lang = 'en';
              this.langID = 1;
              //this.getFaq(this.langID);
          });
      }

      if (myLang == 'ms') {

          translate.get('HOME').subscribe((res: any) => {
              this.lang = 'ms';
              this.langID = 2;
              //this.getFaq(this.langID);
          });
      }
      // this.topnavservice.getEventLang();

      // if(this.topnavservice.flagLangAppMngmnt){
      //   console.log(this.langID);
      // }

      this.getDSName();

      if(this.langID == 1){
        this.geolokasi1 = '(get directions using';
        this.geolokasi2 = 'or open the'; 
        this.geolokasi3 = ' app)</p>';
        this.geolokasiT = 'Geolocation';
      }
      else{
        this.geolokasi1 = '(dapatkan arah menggunakan';
        this.geolokasi2 = 'atau buka aplikasi';
        this.geolokasi3 = '';
        this.geolokasiT = 'Geolokasi';
      }

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = this.translate.instant('education.schoolSearch.topTitle2');
          this.sharedService.setTitle(title);
        }); 
      },500); 
    });    

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });
    
    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      if (localStorage.getItem('customFontType')) {
        this.fontType = localStorage.getItem('customFontType');
      }
      this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
      //$('.mat-input-placeholder').css('font-size', this.fontSize.sizeS)      
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
      this.mStyle = 'style="margin: 0px; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
     // $('.mat-input-placeholder').css('font-family', this.fontType);
    });
  }

  ngOnDestroy() {
    // this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
  }

  ngOnInit() {

    if(!this.langID){
      if (localStorage.getItem('langID')) {
        this.langID = localStorage.getItem('langID');
      } else {
        this.langID = 1;    
      }
    }

    let sub = this.route.queryParams.subscribe((params: Params) => {
      this.dsvcCode = parseInt(params.service);
      this.agcCode = parseInt(params.agency);
    });

    this.gotoUrl(this.dsvcCode);
    this.getDSName();

    // if(this.currlang == 'English'){
    //   this.isActive = true;
    // }else{
    //   this.isActive = false;
    // }

    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   const myLang = this.translate.currentLang;
    //   if (myLang === 'ms') {
    //     this.isActive = true; 
    //     this.currlang = 'English';
    //     this.currlangMOB = 'EN';
    //     //this.translate.use('ms');
    //     this.langID = 2;
    //   } else {
    //     this.isActive = false;
    //     this.currlang = 'Bahasa Melayu';
    //     this.currlangMOB = 'BM';
    //     this.langID = 1;
    //     //this.translate.use('en');
    //   }
    //   localStorage.setItem('langID', this.langID);
    //   this.topnavservice.getEventLang();
    // });
    window.scrollTo(0, 0);

    this.optSelect = new FormControl();
    this.state = new FormControl();
    this.typeSchool = new FormControl();
    this.sector = new FormControl();
    this.ppd = new FormControl();
    this.speacialEd = new FormControl();
    this.schoolname = new FormControl();
    this.jenisCarian = new FormControl();
    this.typeLocation = new FormControl();
    this.latitude = new FormControl();
    this.longitude = new FormControl();
    this.distance = new FormControl();
    this.typeKK = new FormControl();
    this.kk = new FormControl();

    this.searchForm = new FormGroup({

      optSelect: this.optSelect,
      state: this.state,
      typeSchool: this.typeSchool,
      sector: this.sector,
      ppd: this.ppd,
      speacialEd: this.speacialEd,
      schoolname: this.schoolname,
      jenisCarian: this.jenisCarian,
      typeLocation: this.typeLocation,
      latitude : this.latitude,
      longitude : this.longitude,
      distance : this.distance
    });
    
    this.kkForm = new FormGroup({

      typeKK: this.typeKK,
      kk: this.kk
    });

    this.getSchoolLevel();
    this.searchForm.get('jenisCarian').setValue(1);
    this.valInstituteLevel = 4; //peringkat 4 : prasekolah;
    this.searchForm.get('typeSchool').disable();
    this.searchForm.get('ppd').disable();
    this.searchForm.get('speacialEd').disable();
    this.searchForm.get('latitude').disable();
    this.searchForm.get('longitude').disable();
    this.getDefaultMap();    

    //document.getElementById("boxCarian").focus();
  }

  gotoUrl(code){
    this.loading = true;
    let a = localStorage.getItem("idDservice");
    this.sharedService.readPortalById('digitalservice/details/',code).subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){
        let getObj = data['object'];    
        if(getObj.surveyUrl){
          this.eRatingUrl = getObj.surveyUrl; 
        } 
        if(getObj.manual){
          this.manualUrl = '/media/documents/'+getObj.manual;
        }
        
      }).bind(this));
      this.loading = false;
    },
    error => {
      this.loading = false;
    });
  }

  ngAfterViewInit() {
 
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = this.translate.instant('education.schoolSearch.topTitle2');
      this.sharedService.setTitleAndGtag(title);
    });
    
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();
    
  }

  openWindow(url) {
    window.open(url, '_blank', 'location=yes, height=570,width=520, scrollbars=yes,status=yes');
  }

  changeJenisCarian(type){
    this.originalRecord = 0;
    this.completeLatLong = false;
    if(type == 3){
      let main = this;
      let mymap = this.mymap;
      let searchForm = this.searchForm;
      let completeLatLong = this.completeLatLong;

      let defaultIcon = L.icon({
        iconUrl: 'assets/marker/marker-icon-yellow.png',
        shadowUrl: 'assets/marker-shadow.png',
        iconSize: [15, 24], // size of the icon 25, 41
        shadowSize: [20, 21], // size of the shadow 40, 41
        iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location
        shadowAnchor: [15/2, 24],  // the same for the shadow
        popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
      });

      //this.searchForm.get('typeLocation').setValue(1);
      this.locateUser();  
      
      this.mymap.on('click', function(e) {
        
        console.log(e);

        if(main.markerUser){
          mymap.removeLayer(main.markerUser);
          mymap.removeLayer(main.circleUser);
        }

        if(main.circleRad){
          mymap.removeLayer(main.circleRad);
        }

        // main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: defaultIcon }).bindPopup((this.langID==1)?'Your selected location':'Lokasi yang dipilih');
        main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: defaultIcon }).bindPopup(e.latlng.lat+","+e.latlng.lng);
        main.circleUser = L.circle([e.latlng.lat, e.latlng.lng], 100, {
            weight: 1,
            color: 'red',
            fillColor: 'red',
            fillOpacity: 0.5
        });  
        mymap.addLayer(main.markerUser);
        mymap.addLayer(main.circleUser);

        if(searchForm.get('distance').value){            
          
          let a = searchForm.get('distance').value
          main.circleRad = L.circle([e.latlng.lat, e.latlng.lng], a, {
              weight: 1,
              color: '#61FF33',
              fillColor: '#61FF33',
              fillOpacity: 0.2
          });            
          mymap.addLayer(main.circleRad);
        }

        searchForm.get('latitude').setValue(e.latlng.lat);
        searchForm.get('longitude').setValue(e.latlng.lng);
        main.completeLatLong = true;
      });
      
    }else{
      this.completeLatLong = true;
      this.mymap.off('click');
    }

  }

  //change position array
  move(arr, old_index, new_index) {
    while (old_index < 0) {
        old_index += arr.length;
    }
    while (new_index < 0) {
        new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
          arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);  
    return arr;
  }
  
  //sort array
  predicateBy(prop){
    return function(a,b){
       if( a[prop] > b[prop]){
           return 1;
       }else if( a[prop] < b[prop] ){
           return -1;
       }
       return 0;
    }
  }
 
  //change category institution
  changeCat(level){
    // this.searchForm.get('typeSchool').reset();// reset type of school
    // this.searchForm.get('sector').reset();
    // this.searchForm.get('state').reset();

    this.valInstituteLevel = level; 
    console.log("this.valInstituteLevel: ", this.valInstituteLevel);

    // if(this.searchForm.get('sector').value && this.valInstituteLevel && this.searchForm.get('state').value){
      
    //   this.getInstitutePpd(this.valInstituteLevel, level.sector, this.searchForm.get('state').value);
    //   this.searchForm.get('typeSchool').enable();
    //   this.searchForm.get('ppd').enable();
    //   this.searchForm.get('speacialEd').enable();      
    // }
    // else{
    //   this.searchForm.get('typeSchool').disable();
    //   this.searchForm.get('ppd').disable();
    //   this.searchForm.get('speacialEd').disable();
    //   this.searchForm.get('ppd').setValue(null);
    //   this.searchForm.get('speacialEd').setValue(null);
    // }

    if(!this.searchForm.get('sector').value || !this.searchForm.get('state').value){
      this.searchForm.get('sector').setValue('A');
      this.searchForm.get('state').setValue('A');
      this.searchForm.get('typeSchool').enable();
      this.searchForm.get('ppd').disable();
      this.searchForm.get('speacialEd').disable();    
    }

    if(this.valInstituteLevel == 4 || this.valInstituteLevel == 5 || this.valInstituteLevel == 6){
      this.searchForm.get('ppd').disable();
      this.searchForm.get('ppd').setValue(null);
      if(this.valInstituteLevel == 6){
        this.searchForm.get('speacialEd').disable();
        this.searchForm.get('speacialEd').setValue(null);
      }

      else{
        this.searchForm.get('speacialEd').enable();
      }
    }

    else{
      this.searchForm.get('ppd').enable();
      this.searchForm.get('speacialEd').enable();    
    }

    this.getInstitutePpd(this.valInstituteLevel, this.searchForm.get('sector').value, this.searchForm.get('state').value);
  }

  //change sector
  changeSector(valSector){

    this.valInstituteLevel = valSector.optSelect;
    this.getInstitutePpd(this.valInstituteLevel, valSector.sector, this.searchForm.get('state').value);
    //when kategori institusi, sector and negeri have value
    // if(valSector.sector && this.valInstituteLevel && this.searchForm.get('state').value){
      
    //   this.getInstitutePpd(this.valInstituteLevel, valSector.sector, this.searchForm.get('state').value);
    //   if(this.valInstituteLevel == 6){
    //     this.searchForm.get('speacialEd').disable();
    //   }else{
    //     this.searchForm.get('speacialEd').enable();
    //   }

    //   if(this.valInstituteLevel == 4 || this.valInstituteLevel == 5 || this.valInstituteLevel == 6){        
    //     this.searchForm.get('ppd').disable();
    //   } else{        
    //     this.searchForm.get('ppd').enable();
    //   }
    //   this.searchForm.get('typeSchool').enable();
    // }else{
    //   this.searchForm.get('typeSchool').disable();
    //   this.searchForm.get('ppd').disable();
    //   this.searchForm.get('speacialEd').disable();
    // }
  }

  changeState(valState){

    this.valInstituteLevel = valState.optSelect;
    this.getInstitutePpd(this.valInstituteLevel, this.searchForm.get('sector').value, valState.state);
  
    //when kategori institusi, sector and negeri have value
    // if(valState.state && this.valInstituteLevel && this.searchForm.get('sector').value){
      
    //   this.getInstitutePpd(this.valInstituteLevel, this.searchForm.get('sector').value, valState.state);
    //   if(this.valInstituteLevel == 6){
    //     this.searchForm.get('speacialEd').disable();
    //   }else{
    //     this.searchForm.get('speacialEd').enable();
    //   }

    //   if(this.valInstituteLevel == 4 || this.valInstituteLevel == 5 || this.valInstituteLevel == 6){        
    //     this.searchForm.get('ppd').disable();
    //   } else{        
    //     this.searchForm.get('ppd').enable();
    //   }
    //   this.searchForm.get('typeSchool').enable();
    // }else{
    //   this.searchForm.get('typeSchool').disable();
    //   this.searchForm.get('ppd').disable();
    //   this.searchForm.get('speacialEd').disable();
    // }
  }

  changeTS(){

    
    let level = this.searchForm.get('optSelect').value;
    let state = this.searchForm.get('state').value;
    let sector = this.searchForm.get('sector').value;
    let ts = this.searchForm.get('typeSchool').value;
    let datappd = this.searchForm.get('ppd').value;

    console.log("Type School: ", ts);

    this.loading = true;
    this.sharedService.getSchoolType('school/byPPD?category='+level+'&negeri='+state+'&sector='+sector+'&institusi='+ts,'').subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){        
        
        this.listPpd = data['data'].ppd;

        // for(let i = 0; i < this.listPpd.length; i++){

        //   if(this.listPpd[i].key == datappd){
        //     this.searchForm.get('ppd').setValue(this.listPpd[i].key);
        //   }
        // }

        if( level != 6 ){ //if ! Institusi Latihan Kemahiran
          if(ts == 26){ // disable OKU for MRSM
            this.searchForm.get('speacialEd').disable();
          }else{
            this.searchForm.get('speacialEd').enable();
          }
        }

        if(this.listPpd.length == 1){ //sekiranya list ppd adalah 'Semua' sahaja
          this.searchForm.get('ppd').setValue(null);
          this.searchForm.get('ppd').disable();
        }else{
          this.searchForm.get('ppd').enable();
        }

      }).bind(this));
      this.loading = false;
    },
    error => {
      this.loading = false;
    });
  }

  changeTypeKK(){
    this.kkForm.get('kk').setValue('');
    if(this.searchForm.controls.jenisCarian.value == 1){
      this.getDataSchool(false, this.limit);
    }
    if(this.searchForm.controls.jenisCarian.value == 2){
      this.getSchoolByName(false, this.limit);
    }
    if(this.searchForm.controls.jenisCarian.value == 3){
      this.getDataSchoolByLocation(false, this.limit);
    }
    this.loading = false;
  }

  getDSName(){
    this.loading = true;
    this.sharedService.readPortalById('digitalservice/details/title/',this.dsvcCode,this.langID).subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){
        
        this.titleServices = data['object'].digitalServiceDetailsTitle;
        console.log(this.titleServices);

      }).bind(this));
      this.loading = false;
    },
    error => {
      this.loading = false;
    });
  }

  // get ppd and type institution/ typeschool
  getInstitutePpd(level,sector,state){
    this.loading = true;
    this.sharedService.getSchoolType('school/type?category='+level+'&state='+state+'&sector='+sector,'').subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){
        
        this.listTypeS = data['data'].jenis_institusi;     
        this.listPpd = data['data'].ppd;

      }).bind(this));
      this.loading = false;
    },
    error => {
      this.loading = false;
    });
  }

  //get school category, sector and state
  getSchoolLevel(){
    this.loading = true;
    //this.sharedService.getSchoolLevel('school/level','').subscribe(
    this.sharedService.getSchoolLevel('school/category','').subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){
        this.listObj = data['data'];     
        this.listLevel = this.listObj.jenis_kategori;
        this.listState = this.listObj.negeri;
        this.listSector = this.listObj.sektor;   
      }).bind(this));
      this.loading = false;
    },
    error => {
      this.loading = false;
    });
  }

  displayPopup(lat, long, nameS, addressS, phone, city, state, peringkat, distance?){
    let display = '';
    let mStyle = this.mStyle;
    let showDistance = "";

    let dataLat = this.searchForm.get('latitude').value;
    let dataLong = this.searchForm.get('longitude').value;
    let getLL = '';

    let address = '';
    address += (addressS) ? addressS+',': '';

    if(dataLat){
      getLL = '&origin='+dataLat+'/'+dataLong;
    }

    if(phone == null){
      phone = 'Tiada';
    }

    if(distance){
      showDistance =`
      <div class='row'>
        <div class='col-xs-2'>
          <i class='fa fa-location-arrow' style='font-size: 1.2em; margin-top: 0px;'></i>
        </div>
        <div class='col-xs-10'>
          <p style='margin-top: 0px; margin-bottom: 0px;'>${distance} m</p>
        </div>
      </div>`
    }

    // if(this.langID == 1){
    //   geolokasi = `(get directions using <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
    //   target='_blank'>Google Maps</a>
    //   or open the <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a> app)</p>`;
    //   geolokasiT = 'Geolocation';
    // }
    // else{
    //   geolokasi = `(dapatkan arah menggunakan <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
    //   target='_blank'>Google Maps</a>
    //   atau buka aplikasi <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a>)</p>`;
    //   geolokasiT = 'Geolokasi';
    // }

    display = `
          <div class='row'>
            <div class='col-xs-12'>
              <h5 class="font-size-s" ${mStyle}>${nameS}<h5>
            </div>
          </div>
          <div class='row'>
            <div class='col-xs-2'>
              <i class='fa fa-home' style='font-size: 1.2em; margin-top: 0px;'></i>
            </div>
            <div class='col-xs-10'>
              <p ${mStyle}>${address} ${city}, ${state}</p>
            </div>
          </div>
          <div class='row'>
            <div class='col-xs-2'>
              <i class='fa fa-phone' style='font-size: 1.2em; margin-top: 0px;'></i>
            </div>
            <div class='col-xs-10'>
              <p ${mStyle}>${phone}</p>
            </div>
          </div>
          <div class='row'>
            <div class='col-xs-2'>
              <i class='fa fa-map-marker' style='font-size: 1.2em; margin-top: 0px;'></i>
            </div>
            <div class='col-xs-10'>
              <p ${mStyle}>${this.geolokasiT}: ${lat},${long} 
              ${this.geolokasi1} <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
              target='_blank'>Google Maps</a> 
              ${this.geolokasi2} <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a>${this.geolokasi3}</p>
            </div>
          </div>
          ${showDistance}`;
    return display;
  }

  updateProgressBar(processed, total, elapsed, layersArray) {
    var progress = document.getElementById('progress');
    var progressBar = document.getElementById('progress-bar');

    if (elapsed > 1000) {
      // if it takes more than a second to load, display the progress bar:
      progress.style.display = 'block';
      progressBar.style.width = Math.round(processed/total*100) + '%';
    }

    if (processed === total) {
      // all markers processed - hide the progress bar:
      progress.style.display = 'none';
    }
  }

  // open popup on map
  goTo(lat, long, nameS, addressS, phone, city, state, distance?) {

    document.getElementById("divPage").scrollIntoView();

    let mStyle = this.mStyle;
    let dataLat = this.searchForm.get('latitude').value;
    let dataLong = this.searchForm.get('longitude').value;
    let getLL = '';

    if(dataLat){
      getLL = '&origin='+dataLat+'/'+dataLong;
    }

    // if(this.langID == 1){
    //   geolokasi = `(get directions using <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
    //   target='_blank'>Google Maps</a>
    //   or open the <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a> app)</p>`;
    //   geolokasiT = 'Geolocation';
    // }
    // else{
    //   geolokasi = `(dapatkan arah menggunakan <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
    //   target='_blank'>Google Maps</a>
    //   atau buka aplikasi <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a>)</p>`;
    //   geolokasiT = 'Geolokasi';
    // }
    // if (lat && long) {
    if (lat != '-' || lat != null) {

      let showDistance = "";

      let address = '';
      address += (addressS) ? addressS+',': '';

      if(phone == null){
        phone = 'Tiada';
      }

      if(distance){
        showDistance =`
        <div class='row'>
          <div class='col-xs-2'>
            <i class='fa fa-location-arrow' style='font-size: 1.2em; margin-top: 0px;'></i>
          </div>
          <div class='col-xs-10'>
            <p ${mStyle}>${distance} m</p>
          </div>
        </div>`
      }

      // this.mymap.setZoom(20,{
      //   "animate": true,
      //   "pan": {
      //     "duration": 1
      //   }
      // });
      // this.mymap.panTo([lat, long], { animate: true, easeLinearity: .20, duration: 2 });   
      //this.mymap.flyTo([dLat, dLong], 13);
      //this.mymap.setView([lat, long], 24); 
      this.mymap.flyTo([lat, long], 16);  
       
      this.popup = L.popup()
        .setLatLng([lat, long])
        .setContent(`
        <div class='row'>
          <div class='col-xs-12'>
            <h5 ${mStyle} >${nameS}<h5>
          </div>
        </div>
        <div class='row'>
          <div class='col-xs-2'>
            <i class='fa fa-home' style='font-size: 1.2em; margin-top: 0px;'></i>
          </div>
          <div class='col-xs-10'>
            <p ${mStyle}>${address} ${city}, ${state}</p>
          </div>
        </div>
        <div class='row'>
          <div class='col-xs-2'>
            <i class='fa fa-phone' style='font-size: 1.2em; margin-top: 0:'></i>
          </div>
          <div class='col-xs-10'>
            <p ${mStyle}>${phone}</p>
          </div>
        </div>
        <div class='row'>
          <div class='col-xs-2'>
            <i class='fa fa-map-marker' style='font-size: 1.2em; margin-top: 0px;'></i>
          </div>
          <div class='col-xs-10'>
            <p ${mStyle}>${this.geolokasiT}: ${lat},${long} 
            ${this.geolokasi1} <a href='https://www.google.com/maps/dir/?api=1${getLL}&destination=${lat},${long}&hl=ms'
            target='_blank'>Google Maps</a> 
            ${this.geolokasi2} <a href='https://hub.grab.com/ul/' target='_blank'>Grab</a>${this.geolokasi3}</p>
          </div>
        </div>
        ${showDistance}
        `)
        .openOn(this.mymap);

    } else{}
  }

  //search school
  getDataSchool(page?, limitPage?){

    this.loading = true;
    let level = this.searchForm.get('optSelect').value;//level
    let state = this.searchForm.get('state').value;//state
    let sect = this.searchForm.get('sector').value;//sector
    let special = this.searchForm.get('speacialEd').value || '';//pendidikan kahs
    let type = this.searchForm.get('typeSchool').value;//jenis sekolah
    let ppd = this.searchForm.get('ppd').value;//ppd
    this.noOfSc = undefined; 

    if(!ppd){
      ppd = 'A';
    }

    if(!type){
      type = 'A';
    }

    if(!special){
      special = 'A';
    }
    
    if(!page){
      page = 0;
    }

    //this.sharedService.getListSchool('school/list',page,level,sect,type,special,state, limitPage).subscribe(
    this.sharedService.getListSchool('school/byCategory',level, state,sect,ppd,type,special,limitPage,page,'').subscribe(
    data => {

      this.sharedService.errorHandling(data, (function () { 

        this.dataAppSchool = data;
        this.recordData = null;
        this.recordData = this.dataAppSchool.list;          
        this.originalRecord = this.dataAppSchool.totalElements;  
        this.pageNo = this.dataAppSchool.pageNumber;          
        this.totalPageNo = Math.ceil(this.dataAppSchool.totalElements / this.limit);
        
        if(data['totalElements'] > 0){                    
          this.showNoData = false;
          // this.loading = false;
        } else{
          this.originalRecord = 0;
          this.showNoData = true;
          this.loading = false;
        }
      }).bind(this));
    },
    error => {
      this.showNoData = true;
      this.errorConnection();
      this.dataAppSchool.totalPages = 0;
      this.totalPageNo = 0;
      this.loading = false;
    });
  }

  getDataSchoolAll(page?, limitPage?, filterby?, ftype?){

    this.loading = true;
    let level = this.searchForm.get('optSelect').value;//level
    let state = this.searchForm.get('state').value;//state
    let sect = this.searchForm.get('sector').value;//sector
    let special = this.searchForm.get('speacialEd').value || '';//pendidikan kahs
    let type = this.searchForm.get('typeSchool').value;//jenis sekolah
    let ppd = this.searchForm.get('ppd').value;//ppd

    if(!ppd){
      ppd = 'A';
    }

    if(!type){
      type = 'A';
    }

    if(!special){
      special = 'A';
    }
    
    this.sharedService.getListSchoolAll('school/byCategory',level, state,sect,ppd,type,special,'A',0, filterby, ftype).subscribe(
    data => {

      this.sharedService.errorHandling(data, (function () { 
       
        if(data['totalElements'] > 0){  
          this.dataAppSchoolAll = data;
          this.recordDataAll = this.dataAppSchoolAll.list;          
          let flaglatlong = false;
          let colorPin = '';
        
          if(this.recordDataAll.length > 0){ 
            

            for (let i = 0; i <= this.recordDataAll.length - 1; i++){
              if(this.recordDataAll[i].lat != '-' && this.recordDataAll[i].lat != null && flaglatlong == false){
                this.setLat = this.recordDataAll[i].lat;
                this.setLong = this.recordDataAll[i].long;
                flaglatlong = true;
              }
            }   

            if(this.searchForm.get('state').value == 'A'){
              this.mymap.setView([4.8142568, 108.5806004], 6);
            } else{
              this.mymap.setView([this.setLat, this.setLong], 8) 
            }   

            if(this.markerGroup){
              this.mymap.removeLayer(this.markerGroup);   
            }

            // this.markerGroup = L.layerGroup();    
            this.markerGroup = L.markerClusterGroup({ chunkedLoading: true});  
            let markerList = [];
            
            for (let i = 0; i <= this.recordDataAll.length - 1; i++) {

              if(this.recordDataAll[i].kategori == '1' || this.recordDataAll[i].kategori == 'Prasekolah'){     
                colorPin = 'marker-icon-green.png';
              }
      
              else if(this.recordDataAll[i].kategori == '2' || this.recordDataAll[i].kategori == 'Sekolah Rendah'){      
                colorPin = 'marker-icon-red.png';    
              }
      
              else if(this.recordDataAll[i].kategori == '3' || this.recordDataAll[i].kategori == 'Sekolah Menengah'){      
                colorPin = 'marker-icon-blue.png';  
              }
      
              else if(this.recordDataAll[i].kategori == '4' || this.recordDataAll[i].kategori == 'Pra Universiti'){     
                colorPin = 'marker-icon-orange.png';   
              }
      
              else if(this.recordDataAll[i].kategori == '5' || this.recordDataAll[i].kategori == 'Pendidikan Tinggi'){          
                colorPin = 'marker-icon-purple.png';   
              }
      
              else if(this.recordDataAll[i].kategori == '6' || this.recordDataAll[i].kategori == 'Institut Latihan Kemahiran'){       
                colorPin = 'marker-icon-grey.png';  
              }

              else{
                colorPin = 'marker-icon-brown.png';  
              }
  
              this.defaultIcon = L.icon({
                iconUrl: 'assets/marker/'+colorPin,
                shadowUrl: 'assets/marker-shadow.png',
                iconSize: [15, 24], // size of the icon 25, 41
                shadowSize: [20, 21], // size of the shadow 40, 41
                iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location [25/2, 41]
                shadowAnchor: [15/2, 24],  // the same for the shadow [25/2, 41]
                popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
              });

              let address = '';
              address += (this.recordDataAll[i].alamat1) ? this.recordDataAll[i].alamat1 : '';
              address += (this.recordDataAll[i].alamat2) ? ', '+ this.recordDataAll[i].alamat2 : '';
              address += (this.recordDataAll[i].alamat3) ?', '+ this.recordDataAll[i].alamat3 : '';
              this.recordDataAll[i].alamat1  = address;
              
              if(parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)) !== 0){
                var marker = L.marker(L.latLng(parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)), parseFloat(this.malformedDataHandler(this.recordDataAll[i].long))), { icon: this.defaultIcon });
                marker.bindPopup(this.displayPopup(
                  parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)),
                  parseFloat(this.malformedDataHandler(this.recordDataAll[i].long)),
                  this.recordDataAll[i].institusi,
                  this.recordDataAll[i].alamat1,
                  this.recordDataAll[i].phone,
                  this.recordDataAll[i].bandar,
                  this.recordDataAll[i].negeri,
                  this.recordDataAll[i].kategori,
                  false
                ));
                markerList.push(marker);
              }                
            }

            this.recordDataAll = this.recordDataAll;
            this.markerGroup.addLayers(markerList);
            this.mymap.addLayer(this.markerGroup);
          } else{
            
            if(this.markerGroup){
              this.mymap.removeLayer(this.markerGroup);   
            }
            this.mymap.setView([4.8142568, 108.5806004], 6);
          }
          this.loading = false;
        }
        else{
          this.loading = false;
        }
      
      }).bind(this));
    },
    error => {
      this.sharedService.showError(this.translate.instant('education.schoolSearch.err'), '');
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.loading = false;
    });
  }

  getDataSchoolByLocation(page?, limitPage?){
    this.loading = true;
    let level = this.searchForm.get('optSelect').value;//level
    let special = 'A';
    let type = 'A';
    let ppd = 'A';
    let sect = 'A';
    let state = 'A';
    let lat = this.searchForm.get('latitude').value;//latitude
    let long = this.searchForm.get('longitude').value;//longitude
    let distance = this.searchForm.get('distance').value;//distance
    this.noOfSc = undefined; 
    
    if(this.searchForm.get('sector').value){
      sect = this.searchForm.get('sector').value
    }

    if(this.searchForm.get('speacialEd').value){
      special = this.searchForm.get('speacialEd').value
    }

    if(!page){
      page = 0;
    }

    this.sharedService.getListSchoolByLocation('school/byLocation',level, state,sect,ppd,type,special,limitPage,page,long, lat,distance, '').subscribe(
    data => {

      this.dataAppSchool = data;
      this.recordData = null;
      this.recordData = this.dataAppSchool.list;          
      this.originalRecord = this.dataAppSchool.totalElements;   
      this.pageNo = this.dataAppSchool.pageNumber;
      this.totalPageNo = Math.ceil(this.dataAppSchool.totalElements / this.limit);
      if(data['totalElements'] > 0){          
        this.showNoData = false;      
        //this.loading = false;
      } else{
        this.originalRecord = 0;
        this.showNoData = true;
        this.loading = false;
      }
    },
    error => {
      this.showNoData = true;
      this.errorConnection();
      this.dataAppSchool.totalPages = 0;
      this.totalPageNo = 0;
      this.loading = false;
    });
  }

  getDataSchoolByLocationAll(page?, limitPage?, filterby?, ftype?){
    this.loading = true;
    let level = this.searchForm.get('optSelect').value;//level
    let special = 'A';
    let type = 'A';
    let ppd = 'A';
    let sect = 'A';
    let state = 'A';
    let lat = this.searchForm.get('latitude').value;//latitude
    let long = this.searchForm.get('longitude').value;//longitude
    let distance = this.searchForm.get('distance').value;//distance

    if(this.searchForm.get('sector').value){
      sect = this.searchForm.get('sector').value
    }

    if(this.searchForm.get('speacialEd').value){
      special = this.searchForm.get('speacialEd').value
    }

    if(!page){
      page = 0;
    }

    this.sharedService.getListSchoolByLocationAll('school/byLocation',level, state,sect,ppd,type,special,limitPage,page,long, lat,distance, filterby, ftype).subscribe(
    data => {

      if(data['totalElements'] > 0){  
        this.dataAppSchoolAll = data;
        this.recordDataAll = this.dataAppSchoolAll.list;
        let flaglatlong = false;
        let colorPin = '';
        
        if(this.recordDataAll.length > 0){ 

          for (let i = 0; i <= this.recordDataAll.length - 1; i++){
            if(this.recordDataAll[i].lat != '-' && this.recordDataAll[i].lat != null && flaglatlong == false){
              this.setLat = this.recordDataAll[i].lat;
              this.setLong = this.recordDataAll[i].long;
              flaglatlong = true;
            }
          }  

          this.mymap.setView([this.searchForm.get('latitude').value, this.searchForm.get('longitude').value], 12);

          if(this.markerGroup){
            this.mymap.removeLayer(this.markerGroup);   
          }
          
          // this.markerGroup = L.layerGroup();   
          this.markerGroup = L.markerClusterGroup({ chunkedLoading: true});  
          let markerList = [];

          for (let i = 0; i <= this.recordDataAll.length - 1; i++) {

            if(this.recordDataAll[i].kategori == '1' || this.recordDataAll[i].kategori == 'Prasekolah'){     
              colorPin = 'marker-icon-green.png';
            }
    
            else if(this.recordDataAll[i].kategori == '2' || this.recordDataAll[i].kategori == 'Sekolah Rendah'){      
              colorPin = 'marker-icon-red.png';    
            }
    
            else if(this.recordDataAll[i].kategori == '3' || this.recordDataAll[i].kategori == 'Sekolah Menengah'){      
              colorPin = 'marker-icon-blue.png';  
            }
    
            else if(this.recordDataAll[i].kategori == '4' || this.recordDataAll[i].kategori == 'Pra Universiti'){     
              colorPin = 'marker-icon-orange.png';   
            }
    
            else if(this.recordDataAll[i].kategori == '5' || this.recordDataAll[i].kategori == 'Pendidikan Tinggi'){          
              colorPin = 'marker-icon-purple.png';   
            }
    
            else if(this.recordDataAll[i].kategori == '6' || this.recordDataAll[i].kategori == 'Institut Latihan Kemahiran'){       
              colorPin = 'marker-icon-grey.png';  
            }

            else{
              colorPin = 'marker-icon-brown.png';  
            }

            this.defaultIcon = L.icon({
              iconUrl: 'assets/marker/'+colorPin,
              shadowUrl: 'assets/marker-shadow.png',
              iconSize: [15, 24], // size of the icon 25, 41
              shadowSize: [20, 21], // size of the shadow 40, 41
              iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location [25/2, 41]
              shadowAnchor: [15/2, 24],  // the same for the shadow
              popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
            });
            
            let address = '';
            address += (this.recordDataAll[i].alamat1) ? this.recordDataAll[i].alamat1 : '';
            address += (this.recordDataAll[i].alamat2) ? ', '+ this.recordDataAll[i].alamat2 : '';
            address += (this.recordDataAll[i].alamat3) ?', '+ this.recordDataAll[i].alamat3 : '';
            this.recordDataAll[i].alamat1  = address;

            if(parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)) !== 0){
              var marker = L.marker(L.latLng(parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)), parseFloat(this.malformedDataHandler(this.recordDataAll[i].long))), { icon: this.defaultIcon });
              marker.bindPopup(this.displayPopup(
                parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)),
                parseFloat(this.malformedDataHandler(this.recordDataAll[i].long)),
                this.recordDataAll[i].institusi,
                this.recordDataAll[i].alamat1,
                this.recordDataAll[i].phone,
                this.recordDataAll[i].bandar,
                this.recordDataAll[i].negeri,
                this.recordDataAll[i].kategori,
                this.recordDataAll[i].jarak
              ));
              markerList.push(marker);
            }  
          }

          this.recordDataAll = this.recordDataAll;
          this.markerGroup.addLayers(markerList);
          this.mymap.addLayer(this.markerGroup);
        } else{
          
          if(this.markerGroup){
            this.mymap.removeLayer(this.markerGroup);   
          }
          this.mymap.setView([4.8142568, 108.5806004], 6);
        }
        this.loading = false;
      }
      else{
        this.loading = false;
      }
      
    },
    error => {
      if(this.langID==1){
        this.sharedService.showError('Your location could not be found. Please ensure your GPS is activated.', '');
      }else{
        this.sharedService.showError('Lokasi anda tidak dapat dijumpai. Sila pastikan GPS anda diaktifkan', '');
      }
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.loading = false;
    });
  }

  //search school by name for data table
  getSchoolByName(page?, limitPage?, val?){
    let valSchoolName = this.searchForm.get('schoolname').value;
    this.loading = true;
    this.noOfSc = undefined; 
    
    if(!page){
      page = 0;
    }

    // this.sharedService.getListSchoolByName('school/search',valSchoolName, page, limitPage).subscribe(
    this.sharedService.getListSchoolByName('school/byKeyword',valSchoolName, page, limitPage, '').subscribe(
    data => {
      this.dataAppSchool = data;
      this.recordData = null;
      this.recordData = this.dataAppSchool.list;
      this.originalRecord = this.dataAppSchool.totalElements;            
      this.pageNo = this.dataAppSchool.pageNumber;        
      this.totalPageNo = Math.ceil(this.dataAppSchool.totalElements / this.limit);

      if(data['totalElements'] > 0){ 
        this.showNoData = false;
        //this.loading = false;
      }else{        
        this.originalRecord = 0;
        this.showNoData = true;
        this.loading = false;
      }
    },
    error => {
      this.showNoData = true;
      this.errorConnection();
      this.dataAppSchool.totalPages = 0;
      this.totalPageNo = 0;
      this.loading = false;
    });
  }  

  //search by name for all marker in map
  getSchoolByNameAll(page?, limitPage?, filterby?, ftype?){
    let valSchoolName = this.searchForm.get('schoolname').value;
    this.loading = true;
    
    if(!page){
      page = 0;
    }

    this.sharedService.getListSchoolByNameAll('school/byKeyword',valSchoolName, 0, 'A', filterby, ftype).subscribe(
    data => {
      
      if(data['totalElements'] > 0){   
        this.dataAppSchoolAll = data;
        this.recordDataAll = null;
        this.recordDataAll = this.dataAppSchoolAll.list;        
        let flaglatlong = false;
        let colorPin = '';

        if(this.recordDataAll.length > 0){ 

          for (let i = 0; i <= this.recordDataAll.length - 1; i++){
            if(this.recordDataAll[i].lat != '-' && this.recordDataAll[i].lat != null && flaglatlong == false){
              this.setLat = this.recordDataAll[i].lat;
              this.setLong = this.recordDataAll[i].long;
              flaglatlong = true;
            }
          }  

          this.mymap.setView([4.8142568, 108.5806004], 6);

          if(this.markerGroup){
            this.mymap.removeLayer(this.markerGroup);   
          }
          
          //this.markerGroup = L.layerGroup();  
          this.markerGroup = L.markerClusterGroup({ chunkedLoading: true});  
          let markerList = [];
          
          for (let i = 0; i <= this.recordDataAll.length - 1; i++) {

            if(this.recordDataAll[i].kategori == '1' || this.recordDataAll[i].kategori == 'Prasekolah'){     
              colorPin = 'marker-icon-green.png';
            }
    
            else if(this.recordDataAll[i].kategori == '2' || this.recordDataAll[i].kategori == 'Sekolah Rendah'){      
              colorPin = 'marker-icon-red.png';    
            }
    
            else if(this.recordDataAll[i].kategori == '3' || this.recordDataAll[i].kategori == 'Sekolah Menengah'){      
              colorPin = 'marker-icon-blue.png';  
            }
    
            else if(this.recordDataAll[i].kategori == '4' || this.recordDataAll[i].kategori == 'Pra Universiti'){     
              colorPin = 'marker-icon-orange.png';   
            }
    
            else if(this.recordDataAll[i].kategori == '5' || this.recordDataAll[i].kategori == 'Pendidikan Tinggi'){          
              colorPin = 'marker-icon-purple.png';   
            }
    
            else if(this.recordDataAll[i].kategori == '6' || this.recordDataAll[i].kategori == 'Institut Latihan Kemahiran'){       
              colorPin = 'marker-icon-grey.png';  
            }

            else{
              colorPin = 'marker-icon-brown.png';  
            }

            this.defaultIcon = L.icon({
              iconUrl: 'assets/marker/'+colorPin,
              shadowUrl: 'assets/marker-shadow.png',
              iconSize: [15, 24], // size of the icon 25, 41
              shadowSize: [20, 21], // size of the shadow 40, 41
              iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location [25/2, 41]
              shadowAnchor: [15/2, 24],  // the same for the shadow
              popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor [0, -41] 
            });

            let address = '';
            address += (this.recordDataAll[i].alamat1) ? this.recordDataAll[i].alamat1 : '';
            address += (this.recordDataAll[i].alamat2) ? ', '+ this.recordDataAll[i].alamat2 : '';
            address += (this.recordDataAll[i].alamat3) ?', '+ this.recordDataAll[i].alamat3 : '';
            this.recordDataAll[i].alamat1  = address;

            if(parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)) !== 0){
              var marker = L.marker(L.latLng(parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)), parseFloat(this.malformedDataHandler(this.recordDataAll[i].long))), { icon: this.defaultIcon });
              marker.bindPopup(this.displayPopup(
                parseFloat(this.malformedDataHandler(this.recordDataAll[i].lat)),
                parseFloat(this.malformedDataHandler(this.recordDataAll[i].long)),
                this.recordDataAll[i].institusi,
                this.recordDataAll[i].alamat1,
                this.recordDataAll[i].phone,
                this.recordDataAll[i].bandar,
                this.recordDataAll[i].negeri,
                this.recordDataAll[i].kategori,
                false
              ));
              markerList.push(marker);
            }  
          }

          this.recordDataAll = this.recordDataAll;
          this.markerGroup.addLayers(markerList);
          this.mymap.addLayer(this.markerGroup);
        }// end if token false
        else{
          if(this.markerGroup){
            this.mymap.removeLayer(this.markerGroup);   
          }
          this.mymap.setView([4.8142568, 108.5806004], 6);
        }
        this.loading = false;
      }else{
        if(this.markerGroup){
          this.mymap.removeLayer(this.markerGroup);   
        }
        this.mymap.setView([4.8142568, 108.5806004], 6);
        this.loading = false;
      }
    },
    error => {

      this.sharedService.showError(this.translate.instant('education.schoolSearch.err'), '');
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.loading = false;
    });
  }  

  //display di map by keyword
  getDataSchoolKey(typeKK, page?, limitPage?, kk?){

    this.loading = true;
    let level = this.searchForm.get('optSelect').value;//level
    let state = this.searchForm.get('state').value;//state
    let sect = this.searchForm.get('sector').value;//sector
    let special = this.searchForm.get('speacialEd').value || '';//pendidikan kahs
    let type = this.searchForm.get('typeSchool').value;//jenis sekolah
    let ppd = this.searchForm.get('ppd').value;//ppd
    let param = '&filtertype='+typeKK+'&filter='+kk;
   
    if(!ppd){
      ppd = 'A';
    }

    if(!type){
      type = 'A';
    }

    if(!special){
      special = 'A';
    }
    
    if(!page){
      page = 0;
    }

    //this.sharedService.getListSchool('school/list',page,level,sect,type,special,state, limitPage).subscribe(
    this.sharedService.getListSchool('school/byCategory',level, state,sect,ppd,type,special,limitPage,page, param).subscribe(
    data => {

      this.sharedService.errorHandling(data, (function () { 

        this.dataAppSchool = data;
        this.recordData = null;
        this.recordData = this.dataAppSchool.list;          
        this.noOfSc = this.dataAppSchool.totalElements;  
        this.pageNo = this.dataAppSchool.pageNumber;          
        this.totalPageNo = Math.ceil(this.dataAppSchool.totalElements / this.limit);
        
        if(data['totalElements'] > 0){                    
          this.showNoData = false;
          // this.loading = false;
        } else{
          this.mymap.setView([4.8142568, 108.5806004], 6);
          if(this.markerGroup){
            this.mymap.removeLayer(this.markerGroup);   
          } 
          this.showNoData = true;
          // this.loading = false;
        }
      }).bind(this));
    },
    error => {
      this.showNoData = true;
      this.sharedService.showError(this.translate.instant('education.schoolSearch.err'), '');
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.dataAppSchool.totalPages = 0;
      this.totalPageNo = 0;
      this.loading = false;
    });
  }

  //display di map by keyword
  getSchoolByNameKey(typeKK, page?, limitPage?, kk?){
    let valSchoolName = this.searchForm.get('schoolname').value;
    let param = '&filtertype='+typeKK+'&filter='+kk;
    this.loading = true;
    
    if(!page){
      page = 0;
    }

    this.sharedService.getListSchoolByName('school/byKeyword',valSchoolName, page, limitPage , param).subscribe(
    data => {
            
      this.dataAppSchool = data;
      this.recordData = null;
      this.recordData = this.dataAppSchool.list;
      this.noOfSc = this.dataAppSchool.totalElements;      
      this.pageNo = this.dataAppSchool.pageNumber;
      this.totalPageNo = Math.ceil(this.dataAppSchool.totalElements / this.limit);
    
      if(data['totalElements'] > 0){          
        this.showNoData = false;
        // this.loading = false;
      }else{     

        this.mymap.setView([4.8142568, 108.5806004], 6);
        if(this.markerGroup){
          this.mymap.removeLayer(this.markerGroup);   
        }   
        this.showNoData = true;
        // this.loading = false;
      }
    },
    error => {
      this.showNoData = true;
      this.sharedService.showError(this.translate.instant('education.schoolSearch.err'), '');
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.dataAppSchool.totalPages = 0;
      this.totalPageNo = 0;
      this.loading = false;
    });
  } 

  //display di map by keyword
  getDataSchoolByLocationKey(typeKK, page?, limitPage?, kk?){
    this.loading = true;
    let level = this.searchForm.get('optSelect').value;//level
    let special = 'A';
    let type = 'A';
    let ppd = 'A';
    let sect = 'A';
    let state = 'A';
    let lat = this.searchForm.get('latitude').value;//latitude
    let long = this.searchForm.get('longitude').value;//longitude
    let distance = this.searchForm.get('distance').value;//distance
    let param = '&filtertype='+typeKK+'&filter='+kk;

    if(this.searchForm.get('sector').value){
      sect = this.searchForm.get('sector').value
    }

    if(this.searchForm.get('speacialEd').value){
      special = this.searchForm.get('speacialEd').value
    }

    if(!page){
      page = 0;
    }

    this.sharedService.getListSchoolByLocation('school/byLocation',level, state,sect,ppd,type,special,limitPage,page,long, lat,distance, param).subscribe(
    data => {

      this.dataAppSchool = data;
      this.recordData = null;
      this.recordData = this.dataAppSchool.list;          
      this.noOfSc = this.dataAppSchool.totalElements;   
      this.pageNo = this.dataAppSchool.pageNumber;
      this.totalPageNo = Math.ceil(this.dataAppSchool.totalElements / this.limit);
      if(data['totalElements'] > 0){          
        this.showNoData = false;      
        // this.loading = false;
      } else{
        this.mymap.setView([4.8142568, 108.5806004], 6);
        if(this.markerGroup){
          this.mymap.removeLayer(this.markerGroup);   
        } 
        this.showNoData = true;
        // this.loading = false;
      }
    },
    error => {
      this.showNoData = true;
      this.errorConnection();
      if(this.markerGroup){
        this.mymap.removeLayer(this.markerGroup);   
      }
      this.dataAppSchool.totalPages = 0;
      this.totalPageNo = 0;
      this.loading = false;
    });
  }

  errorConnection(){
    this.noOfSc = undefined; 
    this.originalRecord = 0;
    this.recordData = null;
  }

  searchRecord(val){
    
    let valTypeKK =val.typeKK;
    this.mymap.closePopup();

    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(()=>{

      if(val.kk && val.kk.length >= 3){
        if(this.searchForm.controls.jenisCarian.value == 1){
          this.getDataSchoolKey(valTypeKK, false, this.limit, val.kk);
          this.getDataSchoolAll(false, this.limit, val.kk, valTypeKK);
        }
        if(this.searchForm.controls.jenisCarian.value == 2){
          this.getSchoolByNameKey(valTypeKK, false, this.limit, val.kk);
          this.getSchoolByNameAll(false, this.limit, val.kk, valTypeKK);
        }
        if(this.searchForm.controls.jenisCarian.value == 3){
          this.getDataSchoolByLocationKey(valTypeKK, false, this.limit, val.kk);
          this.getDataSchoolByLocationAll(false, this.limit, val.kk, valTypeKK);
        }
        // this.loading = false;
      }        
      
      if(val.kk.length == 0){
        if(this.searchForm.controls.jenisCarian.value == 1){
          this.getDataSchool(false, this.limit);
          this.getDataSchoolAll(false, this.limit);
        }
        if(this.searchForm.controls.jenisCarian.value == 2){
          this.getSchoolByName(false, this.limit);
          this.getSchoolByNameAll(false, this.limit);
        }
        if(this.searchForm.controls.jenisCarian.value == 3){
          this.getDataSchoolByLocation(false, this.limit);
          this.getDataSchoolByLocationAll(false, this.limit);
        }
        // this.loading = false;
      }
    }, this.doneTypingInterval);
    
    // if(val.kk && val.kk.length >= 3){
    //   if(this.searchForm.controls.jenisCarian.value == 1){
    //     this.getDataSchoolKey(valTypeKK, false, this.limit, val.kk);
    //   }
    //   if(this.searchForm.controls.jenisCarian.value == 2){
    //     this.getSchoolByNameKey(valTypeKK, false, this.limit, val.kk);
    //   }
    //   if(this.searchForm.controls.jenisCarian.value == 3){
    //     this.getDataSchoolByLocationKey(valTypeKK, false, this.limit, val.kk);
    //   }
    // }

    // if(val.kk.length == 0){
    //   if(this.searchForm.controls.jenisCarian.value == 1){
    //     this.getDataSchool(false, this.limit);
    //   }
    //   if(this.searchForm.controls.jenisCarian.value == 2){
    //     this.getSchoolByName(false, this.limit);
    //   }
    //   if(this.searchForm.controls.jenisCarian.value == 3){
    //     this.getDataSchoolByLocation(false, this.limit);
    //   }
    // }

  }

  //btn search/carian
  searchApp(){
    this.popup.remove();
    this.kkForm.get('typeKK').setValue(1);
    this.kkForm.get('kk').setValue('');
    this.showDetails = true;

    if(this.searchForm.controls.jenisCarian.value == 1){
      this.resetData();
      this.getDataSchool(false, this.limit);
      this.getDataSchoolAll(false, this.limit);
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      this.resetData();
      this.getDataSchoolByLocation(false, this.limit);
      this.getDataSchoolByLocationAll(false, this.limit);
    }
    else{
      this.resetData();
      let a = this.searchForm.controls.schoolname.value
      if(a.trim().length == 0){
        return
      }
      else{        
        this.getSchoolByName(false, this.limit);
        this.getSchoolByNameAll(false, this.limit);
      }
    }
  }         

  convertPK(val){
    if(val == 'Y')
      val = "Ada";
    else
      val = "Tiada";

    return val;
  }

  convertPeringkat(val){
    for(let idx = 0; idx < this.listLevel.length; idx++){
      if(this.listLevel[idx].peringkat == val){
        return this.listLevel[idx]['level_'+this.lang];
      }
    }
  }

  clickUrl(urlsc){

    let a = '';
    let res = '';

    a = urlsc.substring(0, 3);

    if(a.toLowerCase() == 'htt'){
      res = urlsc;
    }

    else{
      res = 'http://'+urlsc;
    }

    // if(a.toLowerCase() == 'www'){
    //   res = 'http://'+urlsc;
    // }

    return res;
  }

  phoneFormat(val){
    if(val != null && val != 0 && val != 'Tidak Berkenaan' && val != 'TIADA'){
      return (!val.startsWith('0')) ? '0'+val : val;
    }else{
      return 'Tidak Berkenaan';
    }
  }

  getDefaultMap() {
    // var esri = require('esri-leaflet'); 
    this.mymap = L.map('dirmap').setView([4.8142568, 108.5806004], 6);
    //this.mymap = L.map('dirmap').setView([-37.82, 175.23], 13);
    // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
    L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '',
      maxZoom: 16,
      id: 'osm.streets', 
      accessToken: 'pk.eyJ1IjoicmVkemEiLCJhIjoiY2pmcGZxNzRrMjYzbzMwcG83bGRxY2FtZyJ9.uMHQpYc0Pvjl4us27nHH8w'
    }).addTo(this.mymap);

    let attribution = this.mymap.attributionControl;
    attribution.setPrefix(false);
  }

  locateUser() {
    this.completeLatLong = false;
    var main = this;
    var mymap = this.mymap;
    var searchForm = this.searchForm;

    this.defaultIcon = L.icon({
      iconUrl: 'assets/marker/marker-icon-yellow.png',
      shadowUrl: 'assets/marker-shadow.png',
      iconSize: [15, 24], // size of the icon 25, 41
      shadowSize: [20, 21], // size of the shadow 40, 41
      iconAnchor: [15/2, 24], // point of the icon which will correspond to marker's location
      shadowAnchor: [15/2, 24],  // the same for the shadow
      popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
    });

    this.mymap.locate({setView : true})
    .on('locationfound', function(e){

      if(main.markerUser){
        mymap.removeLayer(main.markerUser);
        mymap.removeLayer(main.circleUser);
      }

      if(main.circleRad){
        mymap.removeLayer(main.circleRad);
      }

      // main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: main.defaultIcon }).bindPopup((this.langID==1)?'Your location!':'Lokasi anda!');
      main.markerUser = L.marker([e.latlng.lat, e.latlng.lng], { icon: main.defaultIcon }).bindPopup(e.latitude+","+e.longitude);
      main.circleUser = L.circle([e.latlng.lat, e.latlng.lng], 100, {
          weight: 1,
          color: 'red',
          fillColor: 'red',
          fillOpacity: 0.5
      });
      mymap.addLayer(main.markerUser);
      mymap.addLayer(main.circleUser);

      if(searchForm.get('distance').value){
        let a = searchForm.get('distance').value;
        main.circleRad = L.circle([e.latlng.lat, e.latlng.lng], a, {
            weight: 1,
            color: '#61FF33',
            fillColor: '#61FF33',
            fillOpacity: 0.2
        });
        mymap.addLayer(main.circleRad);
      }

      // this.latitude =\
      searchForm.get('latitude').setValue(e.latitude);
      searchForm.get('longitude').setValue(e.longitude);
     
    })
    .on('locationerror', function(e){
      console.log("Location access denied.");
      main.errorMsg();
    });
    
    this.completeLatLong = true;
  }

  errorMsg(){
    if(this.langID==1){
      this.sharedService.showError('Your location could not be found. Please ensure your GPS is activated.', '');
    }else{
      this.sharedService.showError('Lokasi anda tidak dapat dijumpai. Sila pastikan GPS anda diaktifkan', '');
    }
  }

  changeRad(){
    var searchForm = this.searchForm;
    let a = searchForm.get('distance').value;
    let lat = searchForm.get('latitude').value;
    let long = searchForm.get('longitude').value;

    console.log(this.circleRad);

    if(this.circleRad){
      this.mymap.removeLayer(this.circleRad);
    }

    console.log(a, lat, long);
    // if(!lat && !long){
    //   if(this.langID==1){
    //     this.sharedService.showError('Please select your location.', '');
    //   }else{
    //     this.sharedService.showError('Sila lokasi anda.', '');
    //   }
    // }

    if(lat && long){
      this.circleRad = L.circle([lat, long], a, {
        weight: 1,
        color: '#61FF33',
        fillColor: '#61FF33',
        fillOpacity: 0.2
      });

      this.mymap.addLayer(this.circleRad);
    }
  }

  validNameSc(e){
    let a = this.searchForm.controls.schoolname.value;

    // if(a.trim().length == 0){
    //   return
    // }

    if(a){

      if(a.trim().length >= 3){
        this.validNS = false;
      }else{
        this.validNS = true;
      }

      var k = e.keyCode;
      if(k == 13 && a.trim().length >= 3){
        this.popup.remove();
        this.kkForm.get('typeKK').setValue(1);
        this.kkForm.get('kk').setValue('');
        this.showDetails = true;

        this.resetData();
        this.getSchoolByName(false, this.limit);
        this.getSchoolByNameAll(false, this.limit);
      }
    }

    else{
      this.validNS = true;
    }
  }

  // check value to enable button search
  checkReqValues() {

    let reqVal = [];
    let nullPointers:any = [];

    // if(this.searchForm.controls.typeSchool.value == '26' || this.searchForm.controls.typeSchool.value == '36' || this.searchForm.controls.typeSchool.value == '49' || this.searchForm.controls.typeSchool.value == '50' 
    // || this.searchForm.controls.typeSchool.value == '51' || this.searchForm.controls.typeSchool.value == '41'){
    //   this.searchForm.get('ppd').disable();
    //   this.searchForm.get('ppd').setValue(null);
    // }

    // else{
    //   this.searchForm.get('ppd').enable();
    // }
    
    if(this.searchForm.controls.jenisCarian.value == 1){
      reqVal =  ["optSelect", "state","sector"];
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      reqVal =  ["optSelect", "distance"];
    }
    else{
      reqVal =  ["schoolname"];
    }

    for (var reqData of reqVal) {
      let elem = this.searchForm.get(reqData);

      if (elem.value == "" || elem.value == null) {
        elem.setValue(null)
        nullPointers.push(null)
      }
    }

    if(nullPointers.length > 0) {
      
      this.complete = false;
      
    } else {      
      this.complete = true;
    }
  }

  // reset search form values
  resetSearch(){
    
    if(this.markerGroup){
      this.mymap.removeLayer(this.markerGroup); 
      this.mymap.closePopup();
    } 
    if(this.markerUser){
      this.mymap.removeLayer(this.markerUser);
      this.mymap.removeLayer(this.circleUser);
    }
    if(this.circleRad){
      this.mymap.removeLayer(this.circleRad);
    }

    this.mymap.setView([4.8142568, 108.5806004], 6);
    this.valInstituteLevel = 4; //peringkat 4 : prasekolah
    this.searchForm.get('optSelect').reset();
    this.searchForm.get('state').reset();
    this.searchForm.get('typeSchool').reset();
    this.searchForm.get('sector').reset();
    this.searchForm.get('ppd').reset();
    this.searchForm.get('speacialEd').reset();
    this.searchForm.get('schoolname').reset();
    this.searchForm.get('latitude').reset();
    this.searchForm.get('longitude').reset();
    this.searchForm.get('distance').reset();

    this.searchForm.get('typeSchool').disable();
    this.searchForm.get('ppd').disable();
    this.searchForm.get('speacialEd').disable();
    this.kkForm.get('kk').setValue('');

    if(this.searchForm.controls.jenisCarian.value == 3){//reset latlong complete.
      this.completeLatLong = false;
    }

    this.showDetails = false;
    this.checkReqValues(); // check to disable search btn
  }

  // reset all assigned data from search
  resetData(){
    this.recordData = null;
    this.noOfSc = undefined;
  }

  // btn reset form
  resetMethod() {
    this.resetSearch();
    this.resetData();
  }

  /** function to prevent special characters in input field - used in (keypress) */
  preventSpecialChar(e){   
    var k = e.charCode;
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }

  paginatorRL(page, val){

    let kk = this.kkForm.get('kk').value;
    let valTypeKK = this.kkForm.get('typeKK').value;
    
    if(this.searchForm.controls.jenisCarian.value == 1){
      if(kk)
        this.getDataSchoolKey(valTypeKK, (page * this.limit)-this.limit, this.limit, kk);
      else
        this.getDataSchool((page * this.limit)-this.limit, this.limit);
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      if(kk)
        this.getDataSchoolByLocationKey(valTypeKK, (page * this.limit)-this.limit, this.limit, kk);
      else
        this.getDataSchoolByLocation((page * this.limit)-this.limit, this.limit);
    }    
    else{
      if(kk)
        this.getSchoolByNameKey(valTypeKK, (page * this.limit)-this.limit, this.limit, kk);
      else
        this.getSchoolByName((page * this.limit)-this.limit, this.limit, val);
    }
    this.loading = false;
  }

  /** navigate to next list - right arrow */
  paginatorR(page, val){
    let kk = this.kkForm.get('kk').value;
    let valTypeKK = this.kkForm.get('typeKK').value;
   
    if(this.searchForm.controls.jenisCarian.value == 1){
      if(kk)
        this.getDataSchoolKey(valTypeKK, page * this.limit, this.limit, kk);
      else
        this.getDataSchool(page * this.limit, this.limit);
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      if(kk)
        this.getDataSchoolByLocationKey(valTypeKK, page * this.limit, this.limit, kk);
      else
        this.getDataSchoolByLocation(page * this.limit, this.limit);
    }    
    else{
      if(kk)
        this.getSchoolByNameKey(valTypeKK, page * this.limit, this.limit, kk);
      else
        this.getSchoolByName(page * this.limit, this.limit, val);
    }
    this.loading = false;
  }

  /** navigate to prev list - left arrow start page 1 */
  paginatorL1(page, val){
    let kk = this.kkForm.get('kk').value;
    let valTypeKK = this.kkForm.get('typeKK').value;

    if(this.searchForm.controls.jenisCarian.value == 1){
      if(kk)
        this.getDataSchoolKey(valTypeKK, (page-1)*this.limit, this.limit, kk);
      else
        this.getDataSchool((page-1)*this.limit, this.limit);
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      if(kk)
        this.getDataSchoolByLocationKey(valTypeKK, (page-1) * this.limit, this.limit, kk);
      else
        this.getDataSchoolByLocation((page-1) * this.limit, this.limit);
    } 
    else{
      if(kk)
        this.getSchoolByNameKey(valTypeKK, (page-1) * this.limit, this.limit, kk);
      else
        this.getSchoolByName((page-1) * this.limit, this.limit, val);
    }
    this.loading = false;
  }

  paginatorL(page, val){
    let kk = this.kkForm.get('kk').value;
    let valTypeKK = this.kkForm.get('typeKK').value;

    if(this.searchForm.controls.jenisCarian.value == 1){
      if(kk)
        this.getDataSchoolKey(valTypeKK, (page-1)*this.limit, this.limit, kk);
      else
        this.getDataSchool((page-1)*this.limit, this.limit);
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      if(kk)
        this.getDataSchoolByLocationKey(valTypeKK, (page-1) * this.limit, this.limit, kk);
      else
        this.getDataSchoolByLocation((page-1) * this.limit, this.limit);
    } 
    else{
      if(kk)
        this.getSchoolByNameKey(valTypeKK, (page-1) * this.limit, this.limit, kk);
      else
        this.getSchoolByName((page-1) * this.limit, this.limit, val);
    }
    this.loading = false;
  }

  pageChange(event){
    let kk = this.kkForm.get('kk').value;
    let valTypeKK = this.kkForm.get('typeKK').value;
    this.limit = event.value;
    let position = $('#boxHasil').position();
 
    if(position){      
      $('.container').scrollTop(position.top);
    }  

    if(this.searchForm.controls.jenisCarian.value == 1){
      this.resetData();
      if(kk)
        this.getDataSchoolKey(valTypeKK, false, this.limit, kk);
      else
        this.getDataSchool(false, this.limit);
    }
    else if(this.searchForm.controls.jenisCarian.value == 3){
      this.resetData();
      if(kk)
        this.getDataSchoolByLocationKey(valTypeKK, false, this.limit, kk);
      else
        this.getDataSchoolByLocation(false, this.limit);
    }
    else{
      this.resetData();
      if(kk)
        this.getSchoolByNameKey(valTypeKK, false, this.limit, kk);
      else
        this.getSchoolByName(false, this.limit);
    }
    this.loading = false;
  }
  
  malformedDataHandler(data) {
    let tData;

    if (!data || data === 'undefined' || data == "")
      tData = "0.0"
    else
      tData = data;

    return tData
  }

  // view detail modal
  view(val, type){     
   
    let selectedData = val;
    
    // selectedData['ejenp_desc'] = val.ejenp;
    // selectedData['jenis_desc'] = val.jenis;
    // selectedData['no_faks'] = val.no_faks;
    // selectedData['no_telefon'] = val.no_telefon;
    // selectedData['peringkat_desc'] = this.convertPeringkat(val.peringkat);
    // selectedData['prasekolah_desc'] = this.convertPK(val.prasekolah);
    // selectedData['pkhas'] = this.convertPK(val.pkhas);
     
    this.dialog.open(SchoolPopupDialog, {
      data: {
        dataschool: val,
        typeData: type,
      }
    });
  }
}

@Component({
  selector: 'school-addinfo',
  templateUrl: './school-addinfo.html',
  styleUrls: ['./school-addinfo.css']
})

export class SchoolPopupDialog {

  flagPrint: any;
  constructor(
    public dialogRef: MatDialogRef<SchoolPopupDialog>,
    private translate: TranslateService,
    private router: Router,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    ngOnInit(){

      if(this.data.typeData == 1){
        this.dialogRef.updatePosition({ top: '0'});
      }
    }

    onNoClick() {
      this.dialogRef.close();
    }

    clickUrl2(urlsc){

      let a = '';
      let res = '';
  
      a = urlsc.substring(0, 3);
  
      if(a.toLowerCase() == 'htt'){
        res = urlsc;
      }
  
      else{
        res = 'http://'+urlsc;
      }
  
      // if(a.toLowerCase() == 'www'){
      //   res = 'http://'+urlsc;
      // }
  
      return res;
    }
    
    onPrint(){
      window.print();
    }
}



// WEBPACK FOOTER //
// ./src/app/schoolsearch/schoolsearch.component.ts